import api from "../../api";
import {param, typedQuery} from "../typing";
import {ResolveOwner, OwnerId, ProductType} from "platformed-client/types";
import * as batshit from "@yornaath/batshit";
import {resolver, scheduler} from "../batch";

const batch = batshit.create({fetcher: api.owners.load, resolver: resolver("owner_id"), scheduler});

export const resolvedOwner = typedQuery(["resolvedOwner", param<ResolveOwner>()], async resolveOwner => {
  const owners = await api.owners.resolve([resolveOwner]);
  return owners[0];
});

export const owner = typedQuery(["owner", param<OwnerId>("ownerId")], async ownerId => {
  return await batch.fetch(ownerId);
});

// `product` scopes the list to owners (users) who can access that product. Pass
// "All" (the ProductContext default outside a product) to list every owner.
export const owners = typedQuery(["owners", param<ProductType>("product")], async product => {
  return await api.owners.list(product);
});
